import { useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Camera, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ProofOfDeliveryDialog({ job, open, onOpenChange, onDone }) {
  const [photo, setPhoto] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/uploads?kind=pod", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPhoto(data.path); toast.success("Photo uploaded");
    } catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); } finally { setBusy(false); }
  };
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/gigs/jobs/${job.job_id}/status`, { status: "delivered", photo_path: photo, note: note || null }); toast.success("Marked delivered"); onDone?.(); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0B0D12] border-slate-800 max-w-sm" data-testid="pod-dialog">
        <DialogHeader><DialogTitle className="font-display">Proof of delivery</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-400">Snap a photo of the items at the drop-off. Businesses confirm faster when they can see it.</p>
        <label className={`flex flex-col items-center justify-center gap-2 h-36 rounded-xl border-2 border-dashed cursor-pointer transition-colors ${photo ? "border-emerald-500/50 bg-emerald-500/5" : "border-slate-700 hover:border-cyan-500/50"}`} data-testid="pod-dropzone">
          {photo ? <><CheckCircle2 className="w-7 h-7 text-emerald-400" /><span className="text-xs text-emerald-300">Photo attached</span></>
                 : <><Camera className="w-7 h-7 text-slate-500" /><span className="text-xs text-slate-400">{busy ? "Uploading…" : "Tap to take or choose a photo"}</span></>}
          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={pick} disabled={busy} data-testid="pod-file-input" />
        </label>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Left with receptionist, gate 4… (optional)" data-testid="pod-note" className="bg-slate-900 border-slate-800" />
        <div className="flex gap-2">
          <Button onClick={submit} disabled={busy || !photo} data-testid="pod-submit-btn" className="flex-1 bg-amber-400 text-slate-950 hover:bg-amber-300 font-semibold">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Submit & mark delivered"}</Button>
          <Button onClick={submit} disabled={busy || !!photo} variant="outline" data-testid="pod-skip-btn" className="bg-transparent border-slate-700 text-slate-400 text-xs">Skip photo</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
